import { pushIFrameUrl } from '@api/semrush/integration.api';
import { History } from 'react-router-dom';
import { isSemrushMode } from '@constants/app-modes';

declare const INTEGRATION_URL: string;

export const redirectUserTo = (history: History, url: string): void => {
  try {
    if (history != null) {
      history.push(url);
    } else {
      window.location.pathname = url;
    }
    if (isSemrushMode()) {
      pushIFrameUrl(url);
    }
  } catch (e) {
    console.error('HistoryHandler::redirectUserTo', e);
  }
};

export const redirectUserToSearchParams = (
  history: History,
  payload: {
    search: string;
    pathname?: string;
  }
): void => {
  history.push({ search: payload.search, pathname: payload.pathname });
  if (isSemrushMode() && payload.search?.length > 0 && payload.pathname?.length > 0) {
    pushIFrameUrl(payload.pathname);
  }
};

export const linkGoTo = (url: string, plainUrl = false): string | { pathname: string } => {
  if (INTEGRATION_URL) {
    const fullUrl = `${INTEGRATION_URL}${url}`;

    if (plainUrl) {
      return fullUrl;
    }

    return {
      pathname: fullUrl,
    };
  }

  return url;
};
